import { inject, Injectable } from "@angular/core";
import { StreamingHubService } from "../services/streaming-hub.service";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { authServiceActions } from "@pcp/auth";
import { distinctUntilChanged, map, switchMap } from "rxjs";

@Injectable()
export class ConnectWhileAuthenticatedEffects {

    private readonly actions$ = inject(Actions);
    private readonly signalrService = inject(StreamingHubService);


    readonly connectSignalr$ = createEffect(() => this.actions$.pipe(
        ofType(
            authServiceActions.userLoginSuccess,
            authServiceActions.tokenRestoreSuccess,

            authServiceActions.tokenRestoreFailed,
            authServiceActions.userHasBeenLoggedOut,
            authServiceActions.userLoginFailed,
        ),
        map(({ type }) => {
            switch (type) {
                case '[AuthService] Token restore failed':
                case '[AuthService] User has been logged out':
                case '[AuthService] User login failed':
                    return false;
                case '[AuthService] Token restore success':
                case '[AuthService] User login success':
                    return true;
            }
        }),
        distinctUntilChanged(),
        switchMap((connect) => connect ? this.signalrService.startConnection() : this.signalrService.stopConnection()),
    ), { dispatch: false });

}
